
webpack.register(
    'components/dropdown/dropdown-container/dropdown-container',
    function() {
        return require('components/dropdown/dropdown-container/dropdown-container');
    },
    false
);
webpack.register(
    'components/dropdown/dropdown-item/dropdown-item',
    function() {
        return require('components/dropdown/dropdown-item/dropdown-item');
    },
    false
);
webpack.register(
    'components/video-detail/video-card/video-card',
    function() {
        return require('components/video-detail/video-card/video-card');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/dropdown/dropdown-container/dropdown-container' />\r\n<can-import from='components/dropdown/dropdown-item/dropdown-item' />\r\n<can-import from='components/video-detail/video-card/video-card' />\r\n\r\n<section class=\"c-video-feed\">\r\n    <h2 class=\"s-category-title\">{{title}}</h2>\r\n    <div class=\"s-list\">\r\n        <div class=\"s-swim-lane\">\r\n            <div class=\"swiper-container\">\r\n                <div class=\"swiper-wrapper\">\r\n                    {{#if playlist.videos.length}}\r\n                        {{#each playlist.videos}}\r\n                            <div class=\"s-list__item s-item swiper-slide\" data-hash=\"#brightcoveId={{brightcoveId}}&pageTitle={{pageTitle}}\">\r\n                                <video-card {card}=\".\" {swim-lane-title}=\"'{{title}}'\" {card-index}=\"'{{@index}}'\" (on-play)=\"selectCard(%event)\" {{#if isActiveCard(@index)}}active{{/if}}></video-card>\r\n                            </div>\r\n                        {{/each}}\r\n                    {{/if}}\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"s-swiper-button swiper-button-prev\"></div>\r\n            <div class=\"s-swiper-button swiper-button-next\"></div>\r\n        </div>\r\n    </div>\r\n</section>\r\n\r\n");